import { render, staticRenderFns } from "./PageStadiumChat.vue?vue&type=template&id=a8e74ec8&"
import script from "./PageStadiumChat.vue?vue&type=script&lang=js&"
export * from "./PageStadiumChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8e74ec8')) {
      api.createRecord('a8e74ec8', component.options)
    } else {
      api.reload('a8e74ec8', component.options)
    }
    module.hot.accept("./PageStadiumChat.vue?vue&type=template&id=a8e74ec8&", function () {
      api.rerender('a8e74ec8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PageStadiumChat.vue"
export default component.exports